import {
  ICreatePickupDTO,
  IGetPickupDTO,
  IGetPickupResponse,
  IGetPickupsResponse,
  RegionsEndpoints,
  IEditPickupDTO,
} from '@/models/regions.model';
import { ApiResponse, httpClient } from '@/utils';

class DeliveryWarehousesAPI {
  static getDeliveryWarehouses(data: IGetPickupDTO): ApiResponse<IGetPickupsResponse> {
    return httpClient.get<IGetPickupsResponse>(RegionsEndpoints.DELIVERY_WAREHOUSES, { params: data });
  }

  static getDeliveryWarehouse(id: string): ApiResponse<IGetPickupResponse> {
    return httpClient.get<IGetPickupResponse>(`${RegionsEndpoints.DELIVERY_WAREHOUSES}/${id}`);
  }

  static createDeliveryWarehouse(data: ICreatePickupDTO): ApiResponse<IGetPickupResponse> {
    return httpClient.post<IGetPickupResponse>(RegionsEndpoints.DELIVERY_WAREHOUSES, data);
  }

  static updateDeliveryWarehouse({ id, ...data }: IEditPickupDTO): ApiResponse<IGetPickupResponse> {
    return httpClient.put(`${RegionsEndpoints.DELIVERY_WAREHOUSES}/${id}`, data);
  }

  static deleteDeliveryWarehouse(id: string): ApiResponse<IGetPickupResponse> {
    return httpClient.delete(`${RegionsEndpoints.DELIVERY_WAREHOUSES}/${id}`);
  }
}

export default DeliveryWarehousesAPI;
